export default "__VITE_ASSET__f81b43d1__"